import {CatmullRomCurve3, Curve, CurvePath, LineCurve3, Vector3} from "three";

export const getBase64Image = (src:string) => {
    return new Promise(resolve => {
        const img = new Image()
        img.crossOrigin = ''
        img.src = src
        img.onload = function () {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx?.drawImage(img, 0, 0, img.width, img.height)
            const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
            const dataURL = canvas.toDataURL('image/' + ext)
            resolve(dataURL)
        }
    })
}

export const getNodeUUid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const isJSON = (str:string) => {
    let result = false;
    try {
        JSON.parse(str);
        result = true;
    } catch (e){
        result = false;
    }
    return result;
}

export const containStr = (arr:[string], str:string) => {
    let n = arr.length;
    for (let i = 0; i < n; i++) {
        if (arr[i].indexOf(str) != -1) {
            return true;
        }
    }
    return false;
}

export const getCurrentTime =()=>{
    // 创建一个Date对象来获取当前时间
    const currentDate = new Date();

// 使用Date对象的方法获取各个时间组成部分
    const year = currentDate.getFullYear(); // 年份
    const month = currentDate.getMonth() + 1; // 月份（注意月份从0开始，所以需要加1）
    const day = currentDate.getDate(); // 日期
    const hours = currentDate.getHours(); // 小时
    const minutes = currentDate.getMinutes(); // 分钟
    const seconds = currentDate.getSeconds(); // 秒钟

// 将时间组成部分拼接成字符串
    const timeString = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    return timeString
}

export const getPointListBase = (points:[any]) => {
    //根据一个线段不限制直线或折线的坐标数组，
    let minX = points[0].x;
    let minY = points[0].y;
    let maxX = points[0].x;
    let maxY = points[0].y;

// 遍历线段的每个坐标，更新矩形的最小和最大坐标值
    for (let i = 1; i < points.length; i++) {
        let point = points[i];
        minX = Math.min(minX, point.x);
        minY = Math.min(minY, point.y);
        maxX = Math.max(maxX, point.x);
        maxY = Math.max(maxY, point.y);
    }

// 计算矩形的宽度和高度
    let width = maxX - minX;
    let height = maxY - minY;
    return {
        width: width,
        height: height,
        centerX: minX + width / 2,
        centerY: minY + height / 2
    }
}

export function createPath(pointsArr) {
    pointsArr = pointsArr.map((point) => new Vector3(...point)); // 将参数数组转换成点数组的形式
    return new CatmullRomCurve3(pointsArr,false,"catmullrom", 0);
}
